import { LogRepository } from "@domain/repositories/LogRepository";
import UseCase from "@domain/UseCase";
import { Log } from "@domain/models/Log";

type Input = void;

type Output = Promise<Log[]>;

export class GetSystemLogsUseCase implements UseCase<Input, Output> {
  constructor(private readonly logRepository: LogRepository) {}

  async execute() {
    return this.logRepository.getSystemLogs();
  }
}
